(function () {
  var root = document.getElementById("vbc-hp");
  if (!root || root.getAttribute("data-vbc-init")) return;
  root.setAttribute("data-vbc-init", "1");
  var DENIM = "#1e5ab4";

  /* hero video: some themes strip the boolean attributes, so force it */
  var v = root.querySelector("video.hero-bg-video");
  if (v) {
    v.muted = true;
    v.defaultMuted = true;
    v.autoplay = true;
    v.loop = true;
    v.setAttribute("playsinline", "");
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* reveal on scroll */
  var els = root.querySelectorAll(".reveal:not(.in)");
  if (els.length && "IntersectionObserver" in window) {
    var ro = new IntersectionObserver(
      function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) {
            es[i].target.classList.add("in");
            ro.unobserve(es[i].target);
          }
        }
      },
      { threshold: 0.14, rootMargin: "0px 0px -60px 0px" }
    );
    for (var i = 0; i < els.length; i++) ro.observe(els[i]);
  } else {
    for (var j = 0; j < els.length; j++) els[j].classList.add("in");
  }

  /* live same-day dispatch countdown, 12pm Sydney cut-off */
  var dot = root.querySelector(".vbc-pulse-dot");
  var label = dot && dot.nextElementSibling;
  function computeLabel() {
    try {
      var now = new Date();
      var syd = new Date(now.toLocaleString("en-US", { timeZone: "Australia/Sydney" }));
      var cutoff = new Date(syd);
      cutoff.setHours(12, 0, 0, 0);
      var diffMs = cutoff.getTime() - syd.getTime();
      var day = syd.getDay();
      if (day === 0 || day === 6)
        return { text: "Order now, dispatched Monday morning", live: false };
      if (diffMs <= 0)
        return { text: "Order now for next day dispatch", live: true };
      var totalMin = Math.floor(diffMs / 60000);
      var h = Math.floor(totalMin / 60);
      var m = totalMin % 60;
      var t = h > 0 ? h + "h " + m + "m" : m + "m";
      return { text: "Order in the next " + t + " for same-day delivery, Sydney Metro", live: true };
    } catch (e) {
      return { text: "Same-day dispatch, Sydney orders before 12pm", live: false };
    }
  }
  if (dot && label) {
    var tick = function () {
      var s = computeLabel();
      label.textContent = s.text;
      dot.style.background = s.live ? "#2fa45a" : DENIM;
    };
    tick();
    setInterval(tick, 1000);
  }

  /* scroll-driven logo bands */
  (function () {
    var SPEED = 0.55;
    var top = root.querySelector(".vbc-band--denim .vbc-band-track");
    var bot = root.querySelector(".vbc-band--grey .vbc-band-track");
    var section = root.querySelector(".vbc-logostrip");
    if (!top || !bot || !section) return;
    var oneT = 0,
      oneB = 0,
      ticking = false,
      inView = true;
    function apply() {
      ticking = false;
      if (!inView) return;
      if (!oneT) oneT = top.scrollWidth / 3;
      if (!oneB) oneB = bot.scrollWidth / 3;
      if (oneT > 0 && oneB > 0) {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        var txT = -oneT + ((((y * SPEED) % oneT) + oneT) % oneT);
        var txB = -((((y * SPEED) % oneB) + oneB) % oneB);
        top.style.transform = "translate3d(" + txT + "px,0,0)";
        bot.style.transform = "translate3d(" + txB + "px,0,0)";
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (e) {
          inView = e[0].isIntersecting;
          if (inView) onScroll();
        },
        { rootMargin: "300px 0px 300px 0px" }
      ).observe(section);
    }
    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      oneT = 0;
      oneB = 0;
      onScroll();
    });
    setTimeout(function () {
      oneT = 0;
      oneB = 0;
      apply();
    }, 400);
    setTimeout(function () {
      oneT = 0;
      oneB = 0;
      apply();
    }, 1400);
    // Every logo that finishes loading changes the track width, so the loop
    // length is re-measured rather than cached from the first frame.
    var logos = section.querySelectorAll("img");
    for (var k = 0; k < logos.length; k++) {
      logos[k].addEventListener("load", function () {
        oneT = 0;
        oneB = 0;
        onScroll();
      });
    }
  })();

  /* FAQ tabs and accordion */
  (function () {
    var faq = root.querySelector("#faq");
    if (!faq) return;
    var tabBtns = faq.querySelectorAll("[data-vbc-tab]");
    var panels = faq.querySelectorAll("[data-vbc-panel]");
    function setOpen(panel, idx) {
      var qs = panel.querySelectorAll("[data-vbc-q]");
      for (var i = 0; i < qs.length; i++) {
        var on = i === idx;
        var btn = qs[i];
        btn.setAttribute("aria-expanded", on ? "true" : "false");
        var icon = btn.lastElementChild;
        icon.style.borderColor = on ? DENIM : "rgba(10,12,16,0.15)";
        icon.style.transform = on ? "rotate(45deg)" : "rotate(0deg)";
        var path = icon.querySelector("path");
        if (path) path.setAttribute("stroke", on ? DENIM : "#0A0C10");
        btn.nextElementSibling.style.gridTemplateRows = on ? "1fr" : "0fr";
      }
    }
    faq.addEventListener("click", function (e) {
      var t = e.target.closest("[data-vbc-tab]");
      if (t) {
        var idx = +t.getAttribute("data-vbc-tab");
        for (var i = 0; i < tabBtns.length; i++) {
          var on = i === idx;
          tabBtns[i].setAttribute("aria-pressed", on ? "true" : "false");
          tabBtns[i].style.background = on ? "#fff" : "rgba(255,255,255,0.12)";
          tabBtns[i].style.color = on ? DENIM : "#fff";
          panels[i].hidden = !on;
        }
        setOpen(panels[idx], 0);
        return;
      }
      var q = e.target.closest("[data-vbc-q]");
      if (q) {
        var panel = q.closest("[data-vbc-panel]");
        var was = q.getAttribute("aria-expanded") === "true";
        setOpen(panel, was ? -1 : +q.getAttribute("data-vbc-q"));
      }
    });
  })();

  /* inline newsletter, posts to the Klaviyo Subscribers list */
  (function () {
    var KLAVIYO_COMPANY_ID = "VAKjvM";
    var KLAVIYO_LIST_ID = "RceW3j";
    var form = root.querySelector('form input[type="email"]');
    form = form && form.closest("form");
    if (!form) return;
    var busy = false;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (busy) return;
      var field = form.querySelector('input[type="email"]');
      var email = field.value.trim();
      if (email.indexOf("@") === -1) return;
      busy = true;
      var btn = form.querySelector('button, input[type="submit"]');
      if (btn) btn.disabled = true;

      function done(message) {
        var p = document.createElement("p");
        p.className = "text-center text-[15px] font-medium text-white";
        p.textContent = message;
        form.parentNode.replaceChild(p, form);
      }

      fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" +
          KLAVIYO_COMPANY_ID,
        {
          method: "POST",
          headers: { "content-type": "application/json", revision: "2024-10-15" },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: { data: { type: "profile", attributes: { email: email } } }
              },
              relationships: {
                list: { data: { type: "list", id: KLAVIYO_LIST_ID } }
              }
            }
          })
        }
      )
        .then(function (res) {
          if (res.ok) {
            done("You're in. Welcome to the Buda list.");
          } else {
            busy = false;
            if (btn) btn.disabled = false;
            field.setCustomValidity("That did not go through. Try again.");
            field.reportValidity();
            setTimeout(function () {
              field.setCustomValidity("");
            }, 3000);
          }
        })
        .catch(function () {
          busy = false;
          if (btn) btn.disabled = false;
        });
    });
  })();

  /* Get a quote: grow the Typeform panel out of the button */
  (function () {
    var SRC = "https://form.typeform.com/to/nuQOoPro";
    var PHONE = "(02) 9740 1500";
    var TRIGGER = 'a[href*="/pages/get-a-quote"]';
    var EASE = "cubic-bezier(0.32, 0.72, 0, 1)";
    var OPEN_MS = 380,
      CLOSE_MS = 240,
      FADE_MS = 200;
    var overlay = null,
      panel = null,
      frame = null,
      origin = null,
      prevOverflow = "";

    function build() {
      overlay = document.createElement("div");
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.setAttribute("aria-label", "Get a quote");
      overlay.style.cssText =
        "position:fixed;inset:0;display:grid;place-items:center;z-index:2147483000;padding:16px";
      var scrim = document.createElement("button");
      scrim.type = "button";
      scrim.setAttribute("aria-label", "Close");
      scrim.style.cssText =
        "position:absolute;inset:0;background:rgba(9,14,24,0.55);backdrop-filter:blur(3px);border:0;cursor:pointer;opacity:0;transition:opacity " +
        OPEN_MS +
        "ms ease-out";
      scrim.addEventListener("click", close);
      panel = document.createElement("div");
      panel.style.cssText =
        "position:relative;width:min(780px,100%);height:min(660px,100%);background-color:#fff;border-radius:20px;overflow:hidden;box-shadow:0 40px 90px -30px rgba(9,14,24,0.55);will-change:transform";
      var x = document.createElement("button");
      x.type = "button";
      x.setAttribute("aria-label", "Close");
      x.style.cssText =
        "position:absolute;top:10px;right:10px;z-index:2;width:34px;height:34px;display:grid;place-items:center;border-radius:999px;border:0;background:rgba(15,23,42,0.06);color:#0f172a;cursor:pointer;opacity:0;transition:opacity " +
        FADE_MS +
        "ms ease-out";
      x.innerHTML =
        '<svg width="13" height="13" viewBox="0 0 14 14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M1 1l12 12M13 1L1 13"/></svg>';
      x.addEventListener("click", close);
      frame = document.createElement("iframe");
      frame.src = SRC;
      frame.title = "Get a quote";
      frame.setAttribute("allow", "camera; microphone; autoplay; encrypted-media; fullscreen; geolocation");
      frame.style.cssText =
        "width:100%;height:100%;border:0;display:block;opacity:0;transition:opacity " +
        FADE_MS +
        "ms ease-out";
      panel.appendChild(x);
      panel.appendChild(frame);
      var note = document.createElement("p");
      note.style.cssText =
        "position:absolute;bottom:18px;left:0;right:0;text-align:center;font-size:12.5px;color:rgba(255,255,255,0.72);opacity:0;transition:opacity " +
        FADE_MS +
        "ms ease-out";
      note.innerHTML =
        'In a hurry, call <a href="tel:0297401500" style="color:#fff;font-weight:600">' +
        PHONE +
        "</a>";
      overlay.appendChild(scrim);
      overlay.appendChild(panel);
      overlay.appendChild(note);
      overlay._scrim = scrim;
      overlay._x = x;
      overlay._note = note;
      document.body.appendChild(overlay);
    }

    function open(a) {
      if (overlay) return;
      origin = a;
      var b = a.getBoundingClientRect();
      build();
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      var r = panel.getBoundingClientRect();
      overlay._scrim.style.opacity = "1";
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return reveal();
      var sx = Math.max(b.width / r.width, 0.01);
      var sy = Math.max(b.height / r.height, 0.01);
      var dx = b.left + b.width / 2 - (r.left + r.width / 2);
      var dy = b.top + b.height / 2 - (r.top + r.height / 2);
      panel.style.transition = "none";
      panel.style.transform = "translate(" + dx + "px," + dy + "px) scale(" + sx + "," + sy + ")";
      panel.style.borderRadius = "999px";
      panel.style.backgroundColor = DENIM;
      panel.getBoundingClientRect();
      panel.style.transition =
        "transform " + OPEN_MS + "ms " + EASE + ", border-radius " + OPEN_MS + "ms " + EASE +
        ", background-color " + (OPEN_MS - 120) + "ms linear 120ms";
      panel.style.transform = "none";
      panel.style.borderRadius = "20px";
      panel.style.backgroundColor = "#fff";
      setTimeout(reveal, OPEN_MS);
    }
    function reveal() {
      if (!overlay) return;
      frame.style.opacity = "1";
      overlay._x.style.opacity = "1";
      overlay._note.style.opacity = "1";
      overlay._x.focus();
    }
    function close() {
      if (!overlay) return;
      var o = overlay;
      overlay = null;
      frame.style.opacity = "0";
      o._x.style.opacity = "0";
      o._note.style.opacity = "0";
      o._scrim.style.opacity = "0";
      var b = origin && origin.getBoundingClientRect();
      if (b) {
        var r = panel.getBoundingClientRect();
        var sx = Math.max(b.width / r.width, 0.01);
        var sy = Math.max(b.height / r.height, 0.01);
        var dx = b.left + b.width / 2 - (r.left + r.width / 2);
        var dy = b.top + b.height / 2 - (r.top + r.height / 2);
        panel.style.transition =
          "transform " + CLOSE_MS + "ms " + EASE + ", border-radius " + CLOSE_MS + "ms " + EASE +
          ", background-color " + CLOSE_MS + "ms " + EASE;
        panel.style.transform = "translate(" + dx + "px," + dy + "px) scale(" + sx + "," + sy + ")";
        panel.style.borderRadius = "999px";
        panel.style.backgroundColor = DENIM;
      }
      setTimeout(function () {
        if (o.parentNode) o.parentNode.removeChild(o);
        document.body.style.overflow = prevOverflow;
        if (origin && origin.focus) origin.focus();
      }, CLOSE_MS);
    }
    document.addEventListener("click", function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest && e.target.closest(TRIGGER);
      if (!a || !root.contains(a)) return;
      e.preventDefault();
      open(a);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  })();
})();
